import React from "react";
import CustomerListTable from "@commons/customer-management/CustomerListTable";

const CustomerList = () => {
  return <CustomerListTable />;
};

export default CustomerList;
